import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionTypeEnum } from '@/models/Question';
import { DragDropAnswer } from '@/components/question/view/primitives/shared/dnd';
import { CombinationCue } from '@/components/question/view/primitives/standard/CombinationCue';
import { QuestionViewPropsFor } from '@/components/question/view/types';
import {
  cueSlotId,
  useCombinationAnswerView,
} from '@/components/question/view/typologies/combination/useCombinationAnswerView';
import isEmpty from 'lodash/isEmpty';

const surface = 'rounded-2xl border border-base-300 bg-base-200 px-4 py-6';

export function CombinationAnswerView(
  props: QuestionViewPropsFor<QuestionTypeEnum.DND_POSITIONAL>,
) {
  const { cues, tokens, slots, placement, handlePlacementChange, disabled } =
    useCombinationAnswerView(props);
  const { t } = useTranslation('translation', { keyPrefix: 'questionView' });

  if (isEmpty(tokens) && isEmpty(cues)) return null;

  return (
    <DragDropAnswer
      tokens={tokens}
      slots={slots}
      placement={placement}
      onPlacementChange={handlePlacementChange}
      disabled={disabled}
      className={surface}
    >
      <div className="grid grid-cols-[fit-content(40%)_1fr] items-center gap-4">
        {cues.map((cue, index) => (
          <Fragment key={cue.id}>
            <CombinationCue cue={cue} />
            <DragDropAnswer.Slot
              id={cueSlotId(cue.id)}
              ariaLabel={t('combination.slotLabel', {
                cue: cue.text || cue.altText || index + 1,
              })}
              className="min-h-16 h-full"
            />
          </Fragment>
        ))}
      </div>
      <DragDropAnswer.Bank />
    </DragDropAnswer>
  );
}
